export const DEFAULT_TERMINOLOGY = {
    customer: { singular: 'Customer', plural: 'Customers' },
    contact: { singular: 'Contact', plural: 'Contacts' },
    service_location: { singular: 'Service location', plural: 'Service locations' },
    service: { singular: 'Service', plural: 'Services' },
    quote: { singular: 'Quote', plural: 'Quotes' },
    job: { singular: 'Job', plural: 'Jobs' },
    appointment: { singular: 'Appointment', plural: 'Appointments' },
    staff: { singular: 'Staff member', plural: 'Staff' },
    invoice: { singular: 'Invoice', plural: 'Invoices' },
    payment: { singular: 'Payment', plural: 'Payments' },
    expense: { singular: 'Expense', plural: 'Expenses' },
    vendor: { singular: 'Vendor', plural: 'Vendors' },
    bank_transaction: { singular: 'Bank transaction', plural: 'Bank transactions' },
    document: { singular: 'Document', plural: 'Documents' },
};
export function resolveTerminology(overrides) {
    const out = { ...DEFAULT_TERMINOLOGY };
    for (const [k, v] of Object.entries(overrides ?? {})) {
        if (v && v.singular && v.plural)
            out[k] = v;
    }
    return out;
}
export function makeTerms(overrides) {
    const terms = resolveTerminology(overrides);
    const get = (key) => terms[key] ?? { singular: humanize(key), plural: humanize(key) + 's' };
    return {
        one: (k) => get(k).singular,
        many: (k) => get(k).plural,
        a: (k) => get(k).singular.toLowerCase(),
        some: (k) => get(k).plural.toLowerCase(),
    };
}
export function humanize(key) {
    const s = key.replace(/[_-]+/g, ' ').trim();
    return s.charAt(0).toUpperCase() + s.slice(1);
}
//# sourceMappingURL=terminology.js.map